import { moveInArray } from "@/common/utils.array";

export default class SmoothDndHelpers {
  constructor(order) {
    this.order = order;
    this.dragStartedCallbacks = [];

    this.onDropGuards = [];
    this.dragEndIfNotDropCallbacks = [];
    this.beforeDropCallbacks = [];
    this.fromArchiveDropCallbacks = [];
    this.toArchiveDropCallbacks = [];
    this.droppedCallbacks = [];
  }

  onDragStart(event) {
    if (!event.isSource) return;

    this.dragStartedCallbacks.forEach(callback => callback());
  }

  onContainerDrop(dest, event) {
    //когда бросили на контейнер а не в конкретное место
    if (!event || event.addedIndex == null) {
      return;
    }

    if (this.onDropGuards.find(guard => guard())) return;

    //типо в конец и вызываем обычный перенос
    const src = event.payload;
    if (src.obj == dest.obj) {
      event.addedIndex = dest.items.length ? dest.items.length - 1 : 0;
    } else {
      event.addedIndex = dest.items.length;
    }
    this.onDrop(dest, event);
  }

  onDragEnd(event) {
    if (!event || !event.isSource) {
      return;
    }

    this.end = true;
    setTimeout(() => {
      if (!this.end) return;
      this.dragEndIfNotDropCallbacks.forEach(callback => callback());
    }, 200);
  }

  onDrop(dest, event) {
    if (!event || event.addedIndex == null) {
      return;
    }

    if (this.onDropGuards.find(guard => guard())) return;

    this.end = false;
    this.beforeDropCallbacks.forEach(callback => callback());

    this._onDrop(dest, event);
  }

  _onDrop(dest, event) {
    const src = event.payload;
    dest.index = event.addedIndex;

    if (src.obj == dest.obj) {
      //в том же списке остались
      if (src.index == dest.index) {
        //позиция не поменялась
        return;
      }

      moveInArray(dest.items, src.index, dest.index);
    } else {
      //в другой список перенесли
      //удалим его из того списка где взяли
      src.items.splice(src.index, 1);
      //вставим в новый
      dest.items.splice(dest.index, 0, src.item);
    }

    const prevItem = dest.items[dest.index - 1];
    const nextItem = dest.items[dest.index + 1];

    const newOrder = this.order.between(prevItem ? prevItem.order : "", nextItem ? nextItem.order : "");
    src.item.order = newOrder;

    if (src.archive && !dest.archive) {
      //из архива перенесли
      this.fromArchiveDropCallbacks.forEach(callback => {
        callback(src.item);
      });
    }
    if (!src.archive && dest.archive) {
      //в архива перенесли
      this.toArchiveDropCallbacks.forEach(callback => {
        callback(src.item);
      });
    }

    this.droppedCallbacks.forEach(callback =>
      callback({
        obj: dest.obj ? dest.obj : src.obj,
        item: src.item,
        order: newOrder
      })
    );

    if (src.extraItems) {
      src.extraItems.forEach(ei => {
        const eventClone = Object.assign({}, event);
        eventClone.payload = Object.assign({}, event.payload);
        eventClone.payload.extraItems = [];

        if (src.obj != dest.obj) {
          eventClone.addedIndex += 1;
        }
        eventClone.payload.index = eventClone.payload.items.indexOf(ei);
        eventClone.payload.item = ei;

        this._onDrop(dest, eventClone);
      });
    }
  }
}
